export class Routes {
  public static _routes: IRoutes = {
    home: '/',
    auth: '/auth',
    login: '/auth/login',
    register: '/auth/register',
    forgot: '/auth/forgot',
    feed: '/feed',
    profile: '/profile',
    search: '/search',
    dashboard: '/dashboard',
    people: '/people',
    chat: '/chat',
    setting: 'setting',
    calendar: '/dashboard/calendar',
    map: '/dashboard/map',
    chart: '/dashboard/chart',
    walkthrough: '/walkthrough',
    message: '/chat/message'
  };
}

export interface IRoutes {
  home: string;
  dashboard: string;
  people: string;
  chat: string;
  setting: string;
  auth: string;
  login: string;
  register: string;
  forgot: string;
  feed: string;
  profile: string;
  search: string;
  calendar: string;
  map: string;
  chart: string;
  walkthrough: string;
  message: string;
}
